<template>

  <div class="min-vh-100 d-flex justify-content-center align-items-center bg-light-gray">
    <div class="card shadow-sm border-0 rounded-4 overflow-hidden" style="max-width: 420px; width: 100%;">
      <div class="card-body p-5">
        <div class="text-center mb-4">
          <div class="d-inline-flex align-items-center justify-content-center gap-2 mb-2">
            <i class="fa-solid fa-utensils text-theme fs-2" />
            <h2 class="fw-bold text-dark m-0" style="letter-spacing: -0.5px;">
              {{ $ln($brand) }}
            </h2>
          </div>
          <p class="text-muted small">
            {{ $appName }} · {{ $t('Restaurant Management System') }}
          </p>
        </div>
        <h5 class="text-center mb-4 fw-bold text-secondary">
          {{ $t('Login to Your Account') }}
        </h5>
        <div
          v-if="loginFailuredMessage"
          class="alert alert-danger d-flex align-items-center p-1"
          style="font-size: 14px;"
          role="alert"
        >
          <i class="fa-solid fa-circle-exclamation me-2 ms-1" />
          <div>
            {{ $t(loginFailuredMessage) }}
          </div>
        </div>
        <div class="mb-3">
          <label
            for="usernanme"
            class="form-label small fw-bold text-secondary"
          >
            {{ $t('Username') }}
          </label>
          <div class="custom-input-group input-group input-group-sm">
            <span class="input-group-text bg-white border-end-0 text-muted">
              <i class="fa-solid fa-user"></i>
            </span>
            <input
              v-model="v$.form.username.$model"
              type="text"
              class="form-control border-start-0 ps-0"
              name="usernanme"
              id="usernanme"
              placeholder="e.g., somsri.m"
              required
            >
          </div>
          <div v-for="error of v$.form.username.$errors"
            class="d-block invalid-feedback"
            :key="error.$uid"
          >
            {{ error.$message }}
          </div>
        </div>

        <div class="mb-3">
          <label
            class="form-label small fw-bold text-secondary"
            for="password"
          >
            {{ $t('Password') }}
          </label>
          <div class="custom-input-group input-group input-group-sm">
            <span class="input-group-text bg-white border-end-0 text-muted">
              <i class="fa-solid fa-lock" />
            </span>
            <input
              v-model.trim="v$.form.password.$model"
              @input="$event => setTouched('password')"
              :type="showPassword ? 'text': 'password'"
              class="form-control border-start-0 border-end-0 ps-0"
              placeholder="••••••••"
              name="password"
              id="password"
              required
            >
            <span
              class="input-group-text bg-white border-start-0 text-muted cursor-pointer"
              @click="showPWD"
            >
              <a
                class="cursor-pointer"
                style="color: #000000;"
              >
                <i class="far " :class="showPassword ? 'fa-eye': 'fa-eye-slash'" />
              </a>
            </span>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mb-4">
          <div class="form-check">
            <input v-model="form.rememberMe" class="form-check-input shadow-none" type="checkbox" id="rememberMe">
            <label class="form-check-label small text-secondary" for="rememberMe">
              {{ $t('Remember me') }}
            </label>
          </div>
        </div>
        <ladda
          text="Login"
          :btn-class="'btn btn-theme w-100 py-2 fw-bold text-white shadow-sm mb-3'"
          :loading="btnLoading"
          icon="<i class='fa-solid fa-right-to-bracket'></i>"
          :disabled="v$.$invalid"
          @click="handleLogin"
        />

        <div class="text-center">
          <span class="small text-muted">{{ $t("Don't have an account") + '? ' }}</span>

          <router-link
            class="small text-decoration-none text-theme fw-bold"
            to="/register"
          >
            {{ $t('Register here') }}
          </router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required, helpers } from '@vuelidate/validators';
import Ladda from '@/plugins/Ladda.vue';
import Cookies from 'js-cookie';
import { useAuthStore } from '@/stores/auth.store';
export default {
  name: 'Login',
  components: {
    Ladda
  },
  data() {
    return {
      btnLoading: false,
      loginFailuredMessage: '',
      form: {
        username: '',
        password: '',
        rememberMe: false
      },
      showPassword: false,
    }
  },
  validations () {
    return {
      form: {
        username: {
          required: helpers.withMessage(this.$t('Please enter username'), required)
        },
        password: {
          required: helpers.withMessage(this.$t('Please enter password'), required)
        }
      }
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  async mounted() {
  },
  methods: {
    setTouched(theModel) {
      if (theModel == 'username' || theModel == 'all') {this.v$.form.username.$touch()}
      if (theModel == 'password' || theModel == 'all') {this.v$.form.password.$touch()}
    },
    showPWD(){
      this.showPassword = !this.showPassword;
    },
    async handleLogin() {
      this.btnLoading = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.btnLoading = false;
        return;
      }
      useAuthStore().login({
        username: this.form.username,
        password: this.form.password,
        remember: this.form.rememberMe
      }).then((res) => {
        window.location.href = process.env.VUE_APP_URL;
        this.btnLoading = false;
      }).catch((err) => {
        if (err.response && err.response.data.message) {
          this.loginFailuredMessage = err.response.data.message;
          this.btnLoading = false;
          return;
        }
        return;
      });
    }
  },
  created() {
  }
}
</script>
